import { ContactStatus, IContactItem } from "interfaces";
import moment from "moment";
import Select from "components/select";
import { CONTACT_STATUS } from "utills/constants";
import { StylesConfig } from "react-select";
import { get } from "lodash";
import Button from "components/button";
import { ClockIcon } from "@heroicons/react/outline";

interface ContactCardProps {
  data?: IContactItem[];
  pageSize: number;
  currentPage: number;
  _handleChangeStatus: (id: string, status: ContactStatus) => void;
  _handleOpenHistoryModal: (id: string) => void;
}

const colourStyles: StylesConfig<any> = {
  control: (styles) => ({ ...styles, backgroundColor: 'white' }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#E9ECFF" : isFocused ? "#F6F5FE80" : undefined,
      color: get(data, "value", "") === ContactStatus.UNRESOLVED ? "#ED4927" : get(data, "value", "") === ContactStatus.PROCESSING ? "#007AFF" : "#16831C",
      cursor: isDisabled ? 'not-allowed' : 'default',
    };
  },
  singleValue: (styles, { data }) => ({ 
    ...styles,
    color:  get(data, "value", "") === ContactStatus.UNRESOLVED ? "#ED4927" : get(data, "value", "") === ContactStatus.PROCESSING ? "#007AFF" : "#16831C",
  }),
};

export const ContactCard = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _handleChangeStatus,
  _handleOpenHistoryModal
}: ContactCardProps) => {
  return (
    <ul className="bg-white">
      {data.map((item: IContactItem, index: number) => (
        <div
          key={index}
          className="flex flex-col gap-y-4 shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl"
        >
          <li className="relative flex flex-row justify-end">
            <Button 
              className="w-8 h-8 bg-magnolia-600 hover:bg-magnolia-600 active:bg-magnolia-600 active:opacity-85"
              onClick={() => _handleOpenHistoryModal(item.id)}
            >
              <ClockIcon className="w-4 h-4 text-brand-500" />
            </Button>
          </li>
          <li className="relative flex flex-col gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">No</p>
            <p className="flex-1 text-sm leading-6">
              {(currentPage - 1) * pageSize + 1 + index}
            </p>
          </li>
          <li className="relative flex flex-col gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Category vie</p>
            <p className="flex-1 text-sm leading-6">
              {item.support_center_category_name_vi}
            </p>
          </li>
          <li className="relative flex flex-col gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Email/Phone contact
            </p>
            <div className="flex-1 text-sm leading-6">
              <p>{item.email}</p>
              <p>{item.phone ? `(+${item.phone_area_code}) ${item.phone}` : ""}</p>
            </div>
          </li>
          <li className="relative flex flex-col gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Feedback time</p>
            <p className="flex-1 text-sm leading-6">
              {item.created_at ? moment(item.created_at).format("DD/MM/YYYY HH:mm:ss") : ""}
            </p>
          </li>
          <li className="relative flex flex-col gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Feedback</p>
            <p className="flex-1 text-sm leading-6">
              {item.description}
            </p>
          </li>
          <li className="relative flex flex-col gap-x-6 w-40 max-w-full">
            <Select
              options={CONTACT_STATUS}
              id="contact-status"
              placeholder="Select Status"
              className="py-0.5"
              value={CONTACT_STATUS.find((d) => d.value === item.status)}
              onChange={(selected: {label: string; value: ContactStatus}) => _handleChangeStatus(item.id, selected?.value)}
              styles={colourStyles}
            />
          </li>
        </div>
      ))}
    </ul>
  );
};
